import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

type Props = React.PropsWithChildren;

const RequireAuth: React.FC<Props> = ({ children }) => {
	const { user, getIdToken } = useAuth();
	const location = useLocation();

	if (!user && getIdToken()) {
		return null;
	}
	if (!user) {
		return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}${location.hash}` }} />;
	}

	return <>{children}</>;
};

export default RequireAuth;
